export enum SalesOrderCreationEnum {
  UPON_ACCEPTANCE = 'upon_acceptance',
  MANUALLY = 'manually',
}
